module.exports = __webpack_public_path__ + "img/aliyunecs-black.47c0410f.svg";